<!-- //
组件工作台的上部的工具栏
@auth xuyd
@date 2022-11-27
//-->
<template>
  <div class="layout-toolbar">
    <div class="left">
      <span class="tool-item" style="color: #5697f6" @click="handleCmd('import')">
        <i class="iconfont iconfont-import"><span class="text">导入</span></i>
      </span>
      <span class="tool-item" style="color: #5697f6" @click="handleCmd('export')">
        <i class="iconfont iconfont-export"><span class="text">导出</span></i>
      </span>
      <el-divider direction="vertical"/>
      <span class="tool-item" style="color: #2df817" @click="handleCmd('save')">
        <i class="iconfont iconfont-save"><span class="text">保存</span></i>
      </span>
      <span class="tool-item" style="color: #97f6e5" @click="handleCmd('preview')">
       <i class="iconfont iconfont-preview"><span class="text">预览</span></i>
      </span>
      <span class="tool-item" style="color: #97f6e5">
       <el-input-number v-model="scale"
                        size="mini"
                        :min="10"
                        :step="10"
                        :max="100"/>
      </span>
    </div>
    <div class="right">
    </div>
  </div>
</template>

<script>
export default {
  name: 'WbToolBar',
  components: {},
  data() {
    return {
      scale: 100,
    }
  },
  props: {
    toolbarData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    toolbarData: {
      handler: function (val) {
        this.scale = val.scale * 100;
      },
      immediate: true
    },
    scale(val) {
      this.toolbarData.scale = val / 100;
    },

  },
  methods: {

    /**
     * 工具栏操作，保存，预览等
     *
     * @param cmd
     */
    handleCmd(cmd) {
      this.$emit('click', {cmd: cmd});
    },
  }
}
</script>

<style scoped lang="less">
.layout-toolbar {
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  padding: 0 10px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;

  .left {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .right {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: right;
    margin-left: 100px;
  }

  .tool-item {
    cursor: pointer;
    margin-right: 2px;
    padding: 0 10px;
    color: #dadada;

    &:hover {
      background: rgba(0, 0, 0, .25);
      color: #f1f1f1;
    }

    .text {
      font-size: 14px;
      margin: 5px;
    }

    .iconfont {
      font-size: 14px;
    }
  }
}
</style>
